import { useMemo } from 'react';
import { LUNCH_CUTOFF_MINUTES, DINNER_CUTOFF_MINUTES } from '../utils/constants';

/**
 * Custom hook to check meal availability based on current time
 * @param {string} selectedDate - The selected delivery date in YYYY-MM-DD format
 * @returns {object} - Object with lunchAvailable and dinnerAvailable boolean flags
 */
export const useMealAvailability = (selectedDate) => {
  return useMemo(() => {
    // If no date is selected or it's not today, both meals are available
    if (!selectedDate) {
      return {
        lunchAvailable: true,
        dinnerAvailable: true
      };
    }

    const today = new Date();
    const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    // If selected date is not today, both meals are available
    if (selectedDate !== todayString) {
      return {
        lunchAvailable: true,
        dinnerAvailable: true
      };
    }

    // If selected date is today, apply time-based restrictions
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const totalMinutes = hours * 60 + minutes;

    // Lunch disabled: After 12:30 PM
    const lunchDisabled = totalMinutes >= LUNCH_CUTOFF_MINUTES;

    // Dinner disabled: After 6:30 PM
    const dinnerDisabled = totalMinutes >= DINNER_CUTOFF_MINUTES;

    return {
      lunchAvailable: !lunchDisabled,
      dinnerAvailable: !dinnerDisabled
    };
  }, [selectedDate]);
};
